import { Environment } from './environment.interface';

export const environment: Environment = {
	// BASICS
	name: 'develop',
	production: true,

	// URLS
	api_url: 'https://engage-api.clickdealer.dev/',
	search_api_url: 'https://search.click-engage.co.uk/',
	vehicle_image_url: 'https://d2v3ym3wwm11gn.cloudfront.net/',
	brand_image_url: 'https://images.clickdealer.co.uk/brands/',
	deploy_protocol: 'https://',
	deploy_domain: 'engage.clickdealer.dev',
	website_domain: 'https://websites.clickdealer.dev',
	evolution_idd_url: 'https://www.evolutionfunding.com/public/initial-disclosure-document/',
	motion_idd_url: 'https://uat.mycreditnet.co.uk/Register/GetInitialDisclosureDocument',
	evolution_smart_calc_url: 'https://dev-smartcalc.financeproposal.co.uk/finance-proposal-calculator.umd.js',

	// KEYS
	pusher_key: 'aabfe1f52670b846aa9d',
	turnstile_site_key: '0x4AAAAAAENCMDlycr8UROra',

	// VISITOR CHAT
	visitor_chat_account_id: 4738,
	visitor_chat_domain: 'www.clickmotors.co.uk',

	// HELLOSIGN
	hellosign_client_id: '495978c92bb191be3f23128ef4f812c8',

	// GTM SETTINGS
	gtm_container_id: 'GTM-WC3R83P',
	gtm_environment_id: '3',
	gtm_environment_auth: 'daQVTRQ89GlRtgaFdU2S1A',

	// APM SETTINGS
	apm_name: 'dev',

    // PAYMENT PROVIDERS
    atoa_use_sandbox: true,
};
